export default "__VITE_ASSET__CBEKV2xz__"